// ---------------------------------------------------------------------------
// Renderer: Conditional
//
// Evaluates branch conditions and renders the matching branch.
// Delegates to renderBlock for the selected branch body.
// ---------------------------------------------------------------------------

import Konva from "konva";
import { evaluateCondition } from "../shared/condition-evaluator.js";
// During migration: renderBlock is the existing switch-based dispatcher.
// After Phase F wiring, this becomes the registry-based dispatch.
import { renderBlock } from "../VizDslRenderer.js";

export function renderConditional(block, crystalizedData, options) {
  const rootData = crystalizedData[block.id] || {};
  const scopedData = { ...crystalizedData, ...rootData };
  const branches = block.branches || [];
  for (const branch of branches) {
    if (evaluateCondition(branch.when, scopedData)) {
      return renderBlock(branch.then, scopedData, options);
    }
  }
  // Preview mode: render the first branch as a structural preview.
  if (options._preview && branches.length > 0) {
    return renderBlock(branches[0].then, scopedData, { ...options, _preview: true });
  }
  return new Konva.Group();
}
